var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"y_button",on:{"click":_vm.click}},[_c('div',{staticClass:"btn",class:{blue:_vm.blue}},[_vm._t("content",[_vm._v(" 按钮默认文字 ")])],2)])}
var staticRenderFns = []

export { render, staticRenderFns }